import { render, staticRenderFns } from "./Q1.vue?vue&type=template&id=f23dce90&scoped=true&"
import script from "./Q1.vue?vue&type=script&lang=js&"
export * from "./Q1.vue?vue&type=script&lang=js&"
import style0 from "./Q1.vue?vue&type=style&index=0&id=f23dce90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23dce90",
  null
  
)

export default component.exports